var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "200px" },
              attrs: {
                filterable: "",
                clearable: "",
                placeholder: "请选择APP"
              },
              model: {
                value: _vm.searchData.appId,
                callback: function($$v) {
                  _vm.$set(_vm.searchData, "appId", $$v)
                },
                expression: "searchData.appId"
              }
            },
            _vm._l(_vm.appList, function(item, index) {
              return _c("el-option", {
                key: index,
                attrs: { label: item.name, value: item.appId }
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              attrs: { clearable: "", filterable: "", placeholder: "请选择" },
              model: {
                value: _vm.searchData.terminalType,
                callback: function($$v) {
                  _vm.$set(_vm.searchData, "terminalType", $$v)
                },
                expression: "searchData.terminalType"
              }
            },
            [
              _c("el-option", { attrs: { label: "ios", value: "1" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "安卓", value: "2" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "ipad", value: "3" } }),
              _vm._v(" "),
              _c("el-option", { attrs: { label: "安卓pad", value: "4" } })
            ],
            1
          ),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { type: "text", placeholder: "请输入兼容APP版本" },
            model: {
              value: _vm.searchData.appVersion,
              callback: function($$v) {
                _vm.$set(_vm.searchData, "appVersion", $$v)
              },
              expression: "searchData.appVersion"
            }
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.searchFun }
            },
            [_vm._v("查询")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "warning", icon: "el-icon-refresh" },
              on: { click: _vm.resetFun }
            },
            [_vm._v("重置")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-button",
        {
          staticClass: "filter-item",
          attrs: { type: "success", icon: "el-icon-back" },
          on: { click: _vm.returnFun }
        },
        [_vm._v("返 回")]
      ),
      _vm._v(" "),
      _vm.checkPermission(["admin:admin:save"])
        ? _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-plus" },
              on: { click: _vm.addFun }
            },
            [_vm._v("新增")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dropdown",
        [
          _c("el-button", { attrs: { type: "primary", scoped: "" } }, [
            _vm._v("\n      显示/隐藏列\n      "),
            _c("i", { staticClass: "el-icon-arrow-down el-icon--right" })
          ]),
          _vm._v(" "),
          _c(
            "el-dropdown-menu",
            { attrs: { slot: "dropdown" }, slot: "dropdown" },
            _vm._l(_vm.tableColumns, function(column, index) {
              return _c(
                "el-dropdown-item",
                {
                  key: index,
                  nativeOn: {
                    click: function($event) {
                      return _vm.showHide(column.isShow)
                    }
                  }
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      model: {
                        value: column.isShow,
                        callback: function($$v) {
                          _vm.$set(column, "isShow", $$v)
                        },
                        expression: "column.isShow"
                      }
                    },
                    [_vm._v(_vm._s(column.label))]
                  )
                ],
                1
              )
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            "cell-style": _vm.isCenter,
            "header-cell-style": _vm.isCenter,
            "highlight-current-row": ""
          }
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: "序号", width: "50" }
          }),
          _vm._v(" "),
          _vm._l(_vm.tableColumns, function(column, index) {
            return [
              column.isShow
                ? _c("el-table-column", {
                    key: index,
                    attrs: {
                      prop: column.prop,
                      label: column.label,
                      formatter: column.formatter,
                      width: column.width,
                      sortable: column.sortable
                    }
                  })
                : _vm._e()
            ]
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", width: "280", prop: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", title: "修改", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.updateMenu(scope.row)
                          }
                        }
                      },
                      [_vm._v("修改")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger", title: "删除", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.delMenu(scope.row)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pageData.total > 0,
                expression: "pageData.total > 0"
              }
            ],
            attrs: {
              "current-page": _vm.pageData.page,
              "page-sizes": [10, 20, 30, 40, 50, 100, 200, 300, 400, 500],
              "page-size": _vm.pageData.rows,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.pageData.total
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            width: "500px",
            visible: _vm.newadd,
            "before-close": _vm.closeDiglog,
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.newadd = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "addForm",
              staticClass: "mark",
              attrs: {
                model: _vm.addData,
                rules: _vm.rules,
                "label-width": "160px",
                size: "small"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "APP名称：", prop: "appId" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "filter-item",
                      staticStyle: { width: "200px" },
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "请选择APP"
                      },
                      on: { change: _vm.changeAppFun },
                      model: {
                        value: _vm.addData.appId,
                        callback: function($$v) {
                          _vm.$set(_vm.addData, "appId", $$v)
                        },
                        expression: "addData.appId"
                      }
                    },
                    _vm._l(_vm.appList, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: item.appId }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "终端：", prop: "terminalType" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: "请选择"
                      },
                      on: { change: _vm.changeTypeFun },
                      model: {
                        value: _vm.addData.terminalType,
                        callback: function($$v) {
                          _vm.$set(_vm.addData, "terminalType", $$v)
                        },
                        expression: "addData.terminalType"
                      }
                    },
                    [
                      _c("el-option", { attrs: { label: "ios", value: "1" } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "安卓", value: "2" } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "ipad", value: "3" } }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "安卓pad", value: "4" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.addData.appId != ""
                ? _c(
                    "el-form-item",
                    { attrs: { label: "兼容app版本：", prop: "appVersion" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "filter-item",
                          staticStyle: { width: "200px" },
                          attrs: {
                            filterable: "",
                            clearable: "",
                            placeholder: "请选择兼容的APP版本"
                          },
                          model: {
                            value: _vm.addData.appVersion,
                            callback: function($$v) {
                              _vm.$set(_vm.addData, "appVersion", $$v)
                            },
                            expression: "addData.appVersion"
                          }
                        },
                        _vm._l(_vm.versionList, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: item.appVersion,
                              value: item.appVersion
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: " " } },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [_vm._v("提交")]
                  ),
                  _vm._v(" "),
                  _c("el-button", { on: { click: _vm.onCencal } }, [
                    _vm._v("取消")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }